'use client';

import React from 'react';
import { isDesktop } from 'react-device-detect';
import EmptyState from '@/common/components/empty-state';
import Layout from '@/common/components/layout';
import { DefaultFooter } from '@/common/components/themes/footers/default-footer';
import Wrapper from '@/common/components/wrapper';

interface Props {
  content: TrustedHTML | undefined;
  title: string;
}

const DedicatedPersonalPage = ({ content, title }: Props) => {
  function hasText(html: string) {
    const text = html
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, '')
      .trim();
    return text.length > 0;
  }

  if (content && !hasText(String(content))) {
    return (
      <Layout responsiveAppbar={isDesktop}>
        <EmptyState
          className="!static z-0 mb-[140px] mt-[107px]"
          iconSrc="/assets/images/svg/empty-state.svg"
          message="این صفحه به زودی کامل می‌شه!"
        />
        <DefaultFooter />
      </Layout>
    );
  }

  return (
    <Layout responsiveAppbar={isDesktop}>
      <Wrapper className="mx-auto mb-20 mt-10 !h-auto max-w-[1040px] rounded-2xl border border-silver-300 bg-white px-8 pb-8 pt-10">
        <p className="mb-7 text-center font-semibold">{title}</p>
        {content ? (
          <div className="rich-text-content">
            <div
              className="ql-editor"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
        ) : null}
      </Wrapper>
      <DefaultFooter />
    </Layout>
  );
};

export default DedicatedPersonalPage;
